<div class="container-fluid py-3" style="max-width: 1000px;">

  <!-- Encabezado -->
  <div class="d-flex align-items-center mb-3">
    <button class="btn btn-link text-decoration-none px-0 me-2" (click)="goBack()">
      <i class="fas fa-arrow-left"></i> Volver al perfil
    </button>
  </div>

  <div class="card shadow-sm mb-3">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-start flex-wrap">
        <div>
          <h4 class="mb-1"><i class="fas fa-cloud text-primary me-2"></i>Gestión en SAP</h4>
          <div class="text-muted">{{ fullName() }}</div>
          <div class="mt-1">
            <span class="badge bg-light text-dark border me-2">Business Partner: {{ businessPartner || sap?.business_partner || '—' }}</span>
            <span *ngIf="isCreated" class="badge bg-success">Registrado en SAP</span>
            <span *ngIf="!isCreated" class="badge bg-secondary">No registrado en SAP</span>
          </div>
        </div>
        <div class="text-end small text-muted" *ngIf="isCreated">
          <div><i class="far fa-calendar-check me-1"></i> Fecha de creación: <b>{{ sap?.fe_c | date:'dd/MM/yyyy, h:mm a' }}</b></div>
          <div *ngIf="sap?.fe_m"><i class="far fa-calendar-alt me-1"></i> Última modificación: <b>{{ sap?.fe_m | date:'dd/MM/yyyy, h:mm a' }}</b></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Pestañas -->
  <ul class="nav nav-tabs mb-3">
    <li class="nav-item"><a class="nav-link" [class.active]="activeTab==='analisis'" (click)="setTab('analisis')" style="cursor:pointer">Análisis</a></li>
    <li class="nav-item"><a class="nav-link" [class.active]="activeTab==='crear'" (click)="setTab('crear')" style="cursor:pointer">Crear</a></li>
    <li class="nav-item"><a class="nav-link" [class.active]="activeTab==='modificar'" (click)="setTab('modificar')" style="cursor:pointer">Modificar</a></li>
  </ul>

  <!-- ============ ANÁLISIS ============ -->
  <div *ngIf="activeTab==='analisis'">
    <div class="card shadow-sm">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0">Análisis para SAP</h5>
          <button class="btn btn-sm btn-outline-primary" (click)="runAnalyze()" [disabled]="analyzing">
            <i class="fas fa-sync" [class.fa-spin]="analyzing"></i> Re-analizar
          </button>
        </div>

        <div *ngIf="analyzing" class="text-muted"><i class="fas fa-spinner fa-spin"></i> Analizando…</div>

        <div *ngIf="!analyzing">
          <div *ngIf="apto" class="alert alert-success">
            <i class="fas fa-check-circle"></i> El cliente <b>cumple las reglas de SAP</b> y está listo para crearse.
          </div>
          <div *ngIf="apto===false" class="alert alert-warning">
            <i class="fas fa-exclamation-triangle"></i> El cliente <b>no está listo</b>. Corrige lo siguiente:
            <ul class="mb-0 mt-2">
              <li *ngFor="let e of errores">{{ e.message }}</li>
            </ul>
          </div>

          <!-- Resumen de lo que se enviaría a SAP -->
          <div *ngIf="payload?.d" class="mt-3">
            <h6 class="text-muted">Datos que se enviarían a SAP</h6>
            <div class="row g-2 small">
              <div class="col-md-4"><span class="text-muted">Nombre:</span> {{ payload.d.FirstName || '—' }}</div>
              <div class="col-md-4"><span class="text-muted">Apellido:</span> {{ payload.d.LastName || '—' }}</div>
              <div class="col-md-4"><span class="text-muted">Nacimiento:</span> {{ payload.d.BirthDate || '—' }}</div>
              <div class="col-md-4"><span class="text-muted">Profesión:</span> {{ payload.d.BusinessPartnerOccupation || '—' }}</div>
              <div class="col-md-4"><span class="text-muted">Empresa:</span> {{ payload.d.NaturalPersonEmployerName || '—' }}</div>
              <div class="col-md-4"><span class="text-muted">Estado:</span> {{ payload.d.to_BusinessPartnerAddress?.results[0]?.Region || '—' }}</div>
              <div class="col-md-4"><span class="text-muted">Ciudad:</span> {{ payload.d.to_BusinessPartnerAddress?.results[0]?.CityName || '—' }}</div>
              <div class="col-md-8"><span class="text-muted">Dirección:</span> {{ payload.d.to_BusinessPartnerAddress?.results[0]?.StreetName || '—' }}</div>
              <div class="col-md-6"><span class="text-muted">Correo:</span> {{ payload.d.to_BusinessPartnerAddress?.results[0]?.to_EmailAddress?.results[0]?.EmailAddress || '—' }}</div>
              <div class="col-md-6"><span class="text-muted">Teléfonos:</span>
                <span *ngFor="let ph of payload.d.to_BusinessPartnerAddress?.results[0]?.to_PhoneNumber?.results">{{ ph.PhoneNumber }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============ CREAR ============ -->
  <div *ngIf="activeTab==='crear'">
    <div class="card shadow-sm">
      <div class="card-body">
        <h5>Crear cliente en SAP</h5>
        <div *ngIf="isCreated" class="alert alert-info">
          <i class="fas fa-info-circle"></i> Este cliente <b>ya figura como registrado en SAP</b> (Business Partner {{ sap?.business_partner }}). Para actualizar sus datos usa la pestaña <b>Modificar</b>. Si en SAP no existe, puedes reenviar el alta: si SAP responde que ya existe, se mantiene como creado.
        </div>
        <p *ngIf="!isCreated" class="text-muted">Se registrará el cliente en SAP con los datos mostrados en la pestaña <b>Análisis</b>. La fecha de creación se guarda solo si SAP responde correctamente.</p>
        <div *ngIf="aprobado===false" class="alert alert-warning">
          <i class="fas fa-ban"></i> El cliente <b>no está aprobado</b>; no se puede crear en SAP.
        </div>
        <div *ngIf="aprobado!==false && apto===false" class="alert alert-warning">
          <i class="fas fa-exclamation-triangle"></i> No se puede crear todavía: hay observaciones pendientes (revisa <b>Análisis</b>).
        </div>
        <button class="btn btn-success" (click)="doCreate()" [disabled]="processing || !apto || aprobado===false">
          <i class="fas fa-cloud-upload-alt"></i> {{ isCreated ? 'Reenviar alta a SAP' : 'Crear cliente en SAP' }}
        </button>
      </div>
    </div>
  </div>

  <!-- ============ MODIFICAR (formulario editable) ============ -->
  <div *ngIf="activeTab==='modificar'">
    <div class="card shadow-sm">
      <div class="card-body">
        <h5>Modificar cliente en SAP</h5>
        <div *ngIf="!isCreated" class="alert alert-info">
          <i class="fas fa-info-circle"></i> El cliente aún <b>no está creado en SAP</b>. Primero créalo en la pestaña <b>Crear</b>.
        </div>

        <form *ngIf="isCreated && edit" (ngSubmit)="doModify()">
          <p class="text-muted small">Los campos de identidad no se pueden modificar. <b>Editables:</b> fecha de nacimiento, profesión, empresa, correo, teléfonos y cuentas bancarias. Nombre, apellido, estado civil y dirección van de solo lectura (no se envían en modificación).</p>

          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Nombre</label>
              <input class="form-control" [(ngModel)]="edit.FirstName" name="FirstName" disabled>
            </div>
            <div class="col-md-6">
              <label class="form-label">Apellido</label>
              <input class="form-control" [(ngModel)]="edit.LastName" name="LastName" disabled>
            </div>
            <div class="col-md-4">
              <label class="form-label">Estado civil</label>
              <select class="form-select" [(ngModel)]="edit.BusPartMaritalStatus" name="BusPartMaritalStatus" disabled>
                <option value="">—</option>
                <option *ngFor="let m of MARITAL" [value]="m.code">{{ m.name }}</option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label">Fecha de nacimiento</label>
              <input type="date" class="form-control" [(ngModel)]="edit.birthDate" name="birthDate">
            </div>
            <div class="col-md-4">
              <label class="form-label">Profesión</label>
              <select class="form-select" [(ngModel)]="edit.BusinessPartnerOccupation" name="BusinessPartnerOccupation">
                <option value="">—</option>
                <option *ngFor="let o of OCCUPATIONS" [value]="o.code">{{ o.name }}</option>
              </select>
            </div>
            <div class="col-12">
              <label class="form-label">Empresa / Empleador <small class="text-muted">(opcional)</small></label>
              <input class="form-control" [(ngModel)]="edit.NaturalPersonEmployerName" name="NaturalPersonEmployerName" (blur)="validateEdit('NaturalPersonEmployerName')" [class.is-invalid]="editErrors['NaturalPersonEmployerName']">
              <div class="invalid-feedback">{{ editErrors['NaturalPersonEmployerName'] }}</div>
            </div>

            <div class="col-12"><hr class="my-1"><small class="text-muted">Dirección</small></div>
            <div class="col-md-3">
              <label class="form-label">País</label>
              <input class="form-control" [(ngModel)]="edit.Country" name="Country" disabled>
            </div>
            <div class="col-md-3">
              <label class="form-label">Estado</label>
              <input class="form-control" [(ngModel)]="edit.Region" name="Region" disabled>
            </div>
            <div class="col-md-6">
              <label class="form-label">Ciudad</label>
              <input class="form-control" [(ngModel)]="edit.CityName" name="CityName" disabled>
            </div>
            <div class="col-12">
              <label class="form-label">Dirección (calle)</label>
              <input class="form-control" [(ngModel)]="edit.StreetName" name="StreetName" disabled>
            </div>

            <div class="col-12"><hr class="my-1"><small class="text-muted">Contacto</small></div>
            <div class="col-12">
              <label class="form-label">Correo electrónico</label>
              <input class="form-control" [(ngModel)]="edit.EmailAddress" name="EmailAddress" (blur)="validateEdit('EmailAddress')" [class.is-invalid]="editErrors['EmailAddress']">
              <div class="invalid-feedback">{{ editErrors['EmailAddress'] }}</div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Teléfono 1</label>
              <input class="form-control" [(ngModel)]="edit.phone1" name="phone1" (blur)="validateEdit('phone1')" [class.is-invalid]="editErrors['phone1']">
              <div class="invalid-feedback">{{ editErrors['phone1'] }}</div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Teléfono 2</label>
              <input class="form-control" [(ngModel)]="edit.phone2" name="phone2" (blur)="validateEdit('phone2')" [class.is-invalid]="editErrors['phone2']">
              <div class="invalid-feedback">{{ editErrors['phone2'] }}</div>
            </div>

            <div class="col-12" *ngIf="modifyBanks.length"><hr class="my-1"><small class="text-muted">Cuentas bancarias <span class="text-secondary">(se gestionan en el apartado de cuentas del cliente)</span></small></div>
            <div class="col-12" *ngFor="let b of modifyBanks; let i = index">
              <div class="row g-2 align-items-end">
                <div class="col-md-2">
                  <label class="form-label small mb-0">Banco</label>
                  <input class="form-control" [(ngModel)]="b.BankNumber" name="bankNumber{{i}}">
                </div>
                <div class="col-md-5">
                  <label class="form-label small mb-0">Cuenta</label>
                  <input class="form-control" [(ngModel)]="b.BankAccount" name="bankAccount{{i}}">
                </div>
                <div class="col-md-3">
                  <label class="form-label small mb-0">Titular</label>
                  <input class="form-control" [(ngModel)]="b.BankAccountHolderName" name="bankHolder{{i}}">
                </div>
                <div class="col-md-2">
                  <label class="form-label small mb-0">Tipo</label>
                  <input class="form-control" [(ngModel)]="b.BankControlKey" name="bankControl{{i}}">
                </div>
              </div>
            </div>
          </div>

          <div class="mt-3 d-flex align-items-center gap-2">
            <button type="submit" class="btn btn-warning" [disabled]="processing || editHasErrors">
              <i class="fas fa-save"></i> Guardar cambios en SAP
            </button>
            <span *ngIf="editHasErrors" class="text-danger small"><i class="fas fa-exclamation-circle"></i> Corrige los campos marcados.</span>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- ============ BITÁCORA ============ -->
  <div *ngIf="activeTab==='bitacora'">
    <div class="card shadow-sm">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0">Bitácora de consultas</h5>
          <button class="btn btn-sm btn-outline-primary" (click)="loadLogs()" [disabled]="loadingLogs">
            <i class="fas fa-sync" [class.fa-spin]="loadingLogs"></i> Actualizar
          </button>
        </div>
        <div *ngIf="loadingLogs" class="text-muted"><i class="fas fa-spinner fa-spin"></i> Cargando…</div>
        <div *ngIf="!loadingLogs && logs.length===0" class="text-muted">Sin registros todavía.</div>
        <div class="table-responsive" *ngIf="!loadingLogs && logs.length>0">
          <table class="table table-sm table-hover align-middle">
            <thead>
              <tr>
                <th>Fecha</th><th>Acción</th><th>Resultado</th><th>Business Partner</th><th>Usuario</th><th>Obs.</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let l of logs" (click)="openLogDetail(l)" style="cursor:pointer" title="Ver request y response">
                <td class="small">{{ l.createdAt | date:'dd/MM/yyyy, h:mm a' }}</td>
                <td>{{ actionLabel(l.action) }}</td>
                <td>
                  <span *ngIf="l.success" class="badge bg-success">OK</span>
                  <span *ngIf="!l.success" class="badge bg-danger">Falló</span>
                </td>
                <td class="small">{{ l.business_partner || '—' }}</td>
                <td class="small">{{ l.username || '—' }}</td>
                <td class="small">{{ l.errors_count || 0 }} <i class="fas fa-eye text-muted ms-1"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- ============ CARGA MASIVA (próximamente) ============ -->
  <!-- ============ CONFIGURACIÓN DE ENDPOINTS ============ -->
  <div *ngIf="activeTab==='config'">
    <div class="card shadow-sm">
      <div class="card-body">
        <h5>Configuración de endpoints de SAP</h5>
        <p class="text-muted small">Cambia a dónde apunta la integración. Aplica a <b>todo el sistema</b> (no solo a este cliente). Hoy apunta al simulador; cuando GT99 entregue el SAP real, cámbialo aquí.</p>

        <div *ngIf="loadingConfig" class="text-muted"><i class="fas fa-spinner fa-spin"></i> Cargando…</div>

        <div *ngIf="!loadingConfig">
          <div class="alert alert-light border small" *ngIf="config">
            Origen de la configuración:
            <span class="badge bg-secondary ms-1">{{ config.source === 'db' ? 'configurado a mano' : 'por defecto (.env)' }}</span>
            <span *ngIf="config.updated_by" class="text-muted"> · último cambio por {{ config.updated_by }} {{ config.updatedAt | date:'dd/MM/yyyy, h:mm a' }}</span>
          </div>

          <div class="mb-3">
            <span class="text-muted small me-2">Presets:</span>
            <button type="button" class="btn btn-sm btn-outline-secondary me-1" (click)="usePreset('http://localhost:8090')">Simulador local</button>
            <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="useCpiPreset()">SAP CPI (GT99)</button>
            <small class="text-muted d-block mt-1">"SAP CPI" deja sin CSRF y método POST/PUT; luego pega la URL y las credenciales.</small>
          </div>

          <div class="row g-3">
            <div class="col-12">
              <label class="form-label">URL — Crear cliente</label>
              <div class="input-group">
                <select class="form-select" style="max-width:110px" [(ngModel)]="configForm.method_create" name="cfgMethodCreate">
                  <option value="POST">POST</option><option value="PUT">PUT</option><option value="PATCH">PATCH</option>
                </select>
                <input class="form-control" [(ngModel)]="configForm.url_create" name="cfgCreate" placeholder="https://.../http/BP_CrediTotal7">
                <button type="button" class="btn btn-outline-secondary" (click)="copyCreateToModify()" title="Copiar a Modificar">→ Modificar</button>
              </div>
            </div>
            <div class="col-12">
              <label class="form-label">URL — Modificar cliente</label>
              <div class="input-group">
                <select class="form-select" style="max-width:110px" [(ngModel)]="configForm.method_modify" name="cfgMethodModify">
                  <option value="POST">POST</option><option value="PUT">PUT</option><option value="PATCH">PATCH</option>
                </select>
                <input class="form-control" [(ngModel)]="configForm.url_modify" name="cfgModify" placeholder="misma URL que crear (en CPI)">
              </div>
              <small class="text-muted">En CPI es la misma URL que crear. En OData usa <code>{{ '{bp}' }}</code> donde va el Business Partner.</small>
            </div>

            <div class="col-md-6">
              <label class="form-label">Usuario (Basic Auth)</label>
              <input class="form-control" [(ngModel)]="configForm.auth_user" name="cfgAuthUser" placeholder="client id / usuario" autocomplete="off">
            </div>
            <div class="col-md-6">
              <label class="form-label">Clave (Basic Auth) <small class="text-muted">(vacío = no cambia)</small></label>
              <input type="password" class="form-control" [(ngModel)]="configForm.auth_pass" name="cfgAuthPass" [placeholder]="config?.has_auth_pass ? '•••••• (guardada)' : 'client secret / clave'" autocomplete="new-password">
            </div>

            <div class="col-md-4 d-flex align-items-end">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" [(ngModel)]="configForm.use_csrf" name="cfgCsrfSwitch" id="cfgCsrfSwitch">
                <label class="form-check-label" for="cfgCsrfSwitch">Usar token CSRF</label>
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label">Timeout (ms)</label>
              <input type="number" class="form-control" [(ngModel)]="configForm.timeout_ms" name="cfgTimeout">
            </div>
            <div class="col-md-4 d-flex align-items-end">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" [(ngModel)]="configForm.enabled" name="cfgEnabled" id="cfgEnabled">
                <label class="form-check-label" for="cfgEnabled">Integración activa</label>
              </div>
            </div>

            <div class="col-12" *ngIf="configForm.use_csrf">
              <label class="form-label">URL — Token CSRF <small class="text-muted">(GET)</small></label>
              <input class="form-control" [(ngModel)]="configForm.url_csrf" name="cfgCsrf" placeholder="https://sap.../API_BUSINESS_PARTNER/">
            </div>
          </div>

          <div class="mt-3">
            <button class="btn btn-primary" (click)="saveConfig()" [disabled]="savingConfig || !configForm.url_create">
              <i class="fas fa-save"></i> Guardar configuración
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
